import { voiceOutcomes, voiceAnswerTypes, voiceOutcome, voiceAnswer, voicePurpose, voiceDisconnect } from "./voiceCallLabels";
export const voiceMoney = (value, currency = "USD") =>
  value === null
    ? "Pendente"
    : new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits:
          Number(value) !== 0 && Math.abs(Number(value)) < 0.0001 ? 8 : 4,
      }).format(Number(value));
const money = (value) =>
  value === null ||
  (typeof value === "string" &&
    /^-?\d+\.\d{8}$/.test(value) &&
    Number.isFinite(Number(value)));
const count = (value) => Number.isSafeInteger(value) && value >= 0;
export function validVoiceReport(data, period, page) {
  return (
    data?.source === "VOICE_ARCHIVE" &&
    data.readOnly === true &&
    data.conversion?.currency === "BRL" &&
    data.conversion?.source === "BCB_PTAX_SELL_CLOSE" &&
    data.conversion?.basis === "callDate" &&
    data.conversion?.referenceOnly === true &&
    [
      data.summary?.retellTotalBrl,
      data.summary?.twilioTotalBrl,
      data.summary?.totalBrl,
      data.summary?.knownSubtotalBrl,
    ].every(money) &&
    [
      data.summary?.fxPending,
      data.summary?.fxProvisional,
      data.summary?.retellBrlPending,
      data.summary?.twilioBrlPending,
    ].every(count) &&
    (!(data.summary?.retellBrlPending || data.summary?.twilioBrlPending) ||
      data.summary?.totalBrl === null) &&
    data.currency === "USD" &&
    data.scope === "ARCHIVED_FINANCIAL_CALLS_ONLY" &&
    data.period?.dateFrom === period.dateFrom &&
    data.period?.dateTo === period.dateTo &&
    data.period?.timeZone === "America/Sao_Paulo" &&
    data.period?.dateBasis === "callStart" &&
    Number.isFinite(Date.parse(data.generatedAt)) &&
    Date.parse(data.generatedAt) <= Date.now() + 60000 &&
    Number.isFinite(Date.parse(data.expiresAt)) &&
    Date.parse(data.expiresAt) > Date.now() &&
    typeof data.collection?.twilioEnabled === "boolean" &&
    data.collection?.automaticCallsEnabled === false &&
    [
      data.summary?.calls,
      data.summary?.retellPending,
      data.summary?.twilioPending,
      data.summary?.unknownDurations,
      data.summary?.missingDateRecords,
    ].every(count) &&
    typeof data.summary.durationMs === "number" &&
    Number.isFinite(data.summary.durationMs) &&
    data.summary.durationMs >= 0 &&
    [
      data.summary.retellKnownUsd,
      data.summary.retellTotalUsd,
      data.summary.twilioKnownUsd,
      data.summary.twilioTotalUsd,
      data.summary.knownSubtotalUsd,
      data.summary.totalUsd,
    ].every(money) &&
    data.summary.fxPending <= data.summary.calls &&
    data.summary.fxProvisional <= data.summary.calls &&
    data.summary.retellBrlPending <= data.summary.calls &&
    data.summary.twilioBrlPending <= data.summary.calls &&
    data.summary.retellBrlPending >= data.summary.retellPending &&
    data.summary.twilioBrlPending >= data.summary.twilioPending &&
    (!data.summary.fxPending || data.summary.totalBrl === null) &&
    data.summary.retellPending <= data.summary.calls &&
    data.summary.twilioPending <= data.summary.calls &&
    (!(data.summary.retellPending || data.summary.twilioPending) ||
      data.summary.totalUsd === null) &&
    data.pagination?.page === page &&
    count(data.pagination?.total) &&
    count(data.pagination?.totalPages) &&
    data.pagination.total === data.summary.calls &&
    Array.isArray(data.items) &&
    data.items.length <= 25 &&
    data.items.every(
      (row) =>
        (row.destinationNumber === undefined || row.destinationNumber === null || typeof row.destinationNumber === "string" && /^\+[1-9]\d{6,14}$/.test(row.destinationNumber)) &&
        (row.outcome === undefined || Object.prototype.hasOwnProperty.call(voiceOutcomes,row.outcome)) &&
        (row.answerType === undefined || Object.prototype.hasOwnProperty.call(voiceAnswerTypes,row.answerType)) &&
        (row.disconnectionReason === undefined || row.disconnectionReason === null || typeof row.disconnectionReason === "string" && /^[a-z][a-z0-9_]{0,99}$/.test(row.disconnectionReason)) &&
        (row.destinationSource !== "CONFLICT" || row.destinationNumber === null) &&
        (row.retellCostUsd !== null || row.retellCostBrl === null) &&
        (row.twilioCostUsd !== null || row.twilioCostBrl === null) &&
        [row.retellCostBrl, row.twilioCostBrl, row.totalCostBrl].every(money) &&
        ((row.retellCostBrl !== null && row.twilioCostBrl !== null) ||
          row.totalCostBrl === null) &&
        (row.exchange === null
          ? row.retellCostBrl === null && row.twilioCostBrl === null
          : row.exchange?.source === "BCB_PTAX_SELL_CLOSE" &&
            money(row.exchange.rate) &&
            Number(row.exchange.rate) > 0 &&
            /^\d{4}-\d{2}-\d{2}$/.test(row.exchange.rateDate) &&
            row.exchange.rateDate <= row.exchange.callDate &&
            row.exchange.callDate ===
              new Intl.DateTimeFormat("en-CA", {
                timeZone: "America/Sao_Paulo",
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              }).format(new Date(row.startedAt))) &&
        /^call_[a-zA-Z0-9_-]{1,100}$/.test(row.callId) &&
        Number.isFinite(Date.parse(row.startedAt)) &&
        [row.retellCostUsd, row.twilioCostUsd, row.totalCostUsd].every(money) &&
        ((row.retellCostUsd !== null && row.twilioCostUsd !== null) ||
          row.totalCostUsd === null) &&
        (row.durationMs === null ||
          (typeof row.durationMs === "number" &&
            Number.isFinite(row.durationMs) &&
            row.durationMs >= 0)) &&
        (row.twilioDurationSeconds === null ||
          (typeof row.twilioDurationSeconds === "number" &&
            Number.isFinite(row.twilioDurationSeconds) &&
            row.twilioDurationSeconds >= 0)) &&
        typeof row.audioAvailable === "boolean" &&
        typeof row.transcriptAvailable === "boolean"
    )
  );
}
export function voiceReportCsv(data) {
  const safe = (value) =>
    `"${String(value ?? "")
      .replace(/^[=+\-@\t\r]/, "'$&")
      .replace(/"/g, '""')}"`;
  return (
    "\uFEFF" +
    [
      [
        "Ligação",
        "Telefone de destino",
        "Fonte do telefone",
        "Finalidade",
        "Resultado da ligação",
        "Identificação do atendimento",
        "Motivo do encerramento",
        "Código Retell do encerramento",
        "Status Retell",
        "Status Twilio",
        "Início UTC",
        "Duração Retell (segundos)",
        "Retell (USD)",
        "Twilio (USD)",
        "Total da ligação (USD)",
        "Retell estimado (BRL)",
        "Twilio estimado (BRL)",
        "Total estimado (BRL)",
        "Cotação USD/BRL",
        "Data da ligação (Brasília)",
        "Data da cotação",
        "Fonte cambial",
        "Cotação provisória",
        "Situação da mídia",
      ],
      ...data.items.map((row) => [
        row.callId,
        row.destinationNumber ?? "Não informado",
        row.destinationSource ?? "UNAVAILABLE",
        voicePurpose(row),
        voiceOutcome(row),
        voiceAnswer(row),
        voiceDisconnect(row),
        row.disconnectionReason ?? "Não informado",
        row.status ?? "Não informado",
        row.twilioCallStatus ?? "Não informado",
        row.startedAt,
        row.durationMs === null ? "Pendente" : row.durationMs / 1000,
        row.retellCostUsd ?? "Pendente",
        row.twilioCostUsd ?? "Pendente",
        row.totalCostUsd ?? "Pendente",
        row.retellCostBrl ?? "Pendente",
        row.twilioCostBrl ?? "Pendente",
        row.totalCostBrl ?? "Pendente",
        row.exchange?.rate ?? "Pendente",
        row.exchange?.callDate ?? "Pendente",
        row.exchange?.rateDate ?? "Pendente",
        row.exchange?.source ?? "Pendente",
        row.exchange ? (row.exchange.provisional ? "Sim" : "Não") : "Pendente",
        row.mediaState,
      ]),
    ]
      .map((row) => row.map(safe).join(";"))
      .join("\r\n")
  );
}
